/* eslint-disable custom/no-restricted-translation-jsx-untranslated-children-text */
import React from 'react';

import { List, ListItem, ListItemText, Typography } from '@mui/material';

import { useIntl } from '@kamernet/core/Intl';
import { Locale } from '@kamernet/core/Intl/types';

import styles from './Content.module.css';
import { SignUpButton } from './SignUpButton';

interface ContentCityAntisquatProps {
  cityName: string;
}

export const ContentCityAntisquat = ({
  cityName,
}: ContentCityAntisquatProps) => {
  const { locale } = useIntl();

  return locale === Locale.en ? (
    <React.Fragment>
      <Typography
        variant="h1"
        className={styles.title}
      >{`Anti-Squat in ${cityName}, Netherlands`}</Typography>

      <Typography variant="body1" className={styles.paragraph}>
        {`If you're wondering where to find anti-squat housing in ${cityName} then look no
        further than Kamernet. Our platform makes it easy for you to search for
        anti-squat homes near ${cityName} based on your budget and preferences. Choosing
        a place to live on a budget can be challenging, that's where living
        anti-squat in ${cityName} makes life easier. With Kamernet, the journey to find an
        anti-squat home near ${cityName} becomes not only accessible but also tailored
        to meet your unique preferences.`}
      </Typography>
      <Typography
        variant="h3"
        className={styles.title}
      >{`Benefits of Anti-squatting in ${cityName}`}</Typography>
      <Typography className={styles.paragraph}>
        {`Living anti-squat in ${cityName} isn't just about affordability but it's more
        about adopting an adventurous and flexible lifestyle. Renting anti-squat
        housing in ${cityName} offers a distinctive alternative to traditional renting.
        For people looking for a cheap and flexible housing option,
        anti-squatting properties in ${cityName} are the answer. Explore our listings,
        schedule a viewing, and secure your next anti-squat in ${cityName} today.`}
      </Typography>
      <Typography variant="h4" className={styles.title}>
        {`How to find Anti squat in ${cityName} with Kamernet?`}
      </Typography>
      <List component="ol" className={styles.list}>
        <SignUpButton />
        <ListItem className={styles.listItem}>
          <ListItemText primary="Get Kamernet premium account to respond to unlimited adverts" />
        </ListItem>
        <ListItem className={styles.listItem}>
          <ListItemText primary="Choose the plan that's right for you 15-Days, 30-Days, 3-Months" />
        </ListItem>
        <ListItem className={styles.listItem}>
          <ListItemText primary="Enter a payment method to start subscription and respond to adverts." />
        </ListItem>
      </List>
    </React.Fragment>
  ) : (
    <React.Fragment>
      <Typography
        variant="h1"
        className={styles.title}
      >{`Anti kraak in ${cityName}, Nederland`}</Typography>

      <Typography variant="body1" className={styles.paragraph}>
        {`Als je je afvraagt waar je antikraakwoningen in ${cityName} kunt vinden,
            kijk dan niet verder dan Kamernet. Ons platform maakt het makkelijk voor
            je om te zoeken naar antikraak woningen in de buurt van ${cityName} op basis
            van je budget en voorkeuren. Het kiezen van een plek om te wonen met
            een budget kan een uitdaging zijn, dat is waar antikraak wonen in
            ${cityName} het leven makkelijker maakt. Met Kamernet wordt de zoektocht naar een
            antikraakwoning in de buurt van ${cityName} niet alleen toegankelijk, maar
            ook afgestemd op jouw unieke voorkeuren.`}
      </Typography>
      <Typography
        variant="h3"
        className={styles.title}
      >{`Voordelen van antikraak wonen in ${cityName}`}</Typography>
      <Typography className={styles.paragraph}>
        {`Antikraak wonen in ${cityName} gaat niet alleen over betaalbaarheid, maar
            meer over het kiezen voor een avontuurlijke en flexibele
            levensstijl. Antikraak wonen in ${cityName} biedt een onderscheidend
            alternatief voor traditioneel huren.
        Voor mensen die op zoek zijn
            naar een goedkope en flexibele woonoptie zijn antikraak woningen in
            ${cityName} het antwoord. Bekijk ons aanbod, plan een bezichtiging en
            verzeker je van je volgende antikraakwoning in ${cityName} vandaag nog.`}
      </Typography>
      <Typography variant="h4" className={styles.title}>
        {`Hoe vind ik een Anti kraakpand in ${cityName} met Kamernet?`}
      </Typography>
      <List component="ol" className={styles.list}>
        <SignUpButton />
        <ListItem className={styles.listItem}>
          <ListItemText
            primary={`Neem een Kamernet premium account om onbeperkt te reageren op
              advertenties`}
          />
        </ListItem>
        <ListItem className={styles.listItem}>
          <ListItemText primary="Kies het plan dat bij je past 15-dagen, 30-dagen, 3 maanden" />
        </ListItem>
        <ListItem className={styles.listItem}>
          <ListItemText
            primary="Voer een betaalmethode in om het abonnement te starten en op
              advertenties te reageren."
          />
        </ListItem>
      </List>
    </React.Fragment>
  );
};
